import React from 'react';
import { ChevronDown } from 'lucide-react';
import { useMobile } from './MobileContext';
import { AREA_LABEL, isStaffArea } from './areas';
import { switchableAreas } from './savedAppAccounts';
import { C } from './MobileShell';

const SWITCH_LABEL = { lehrer: 'Lehrkraft', eltern: 'Eltern' };

/**
 * Lehrkraft | Eltern stehen beide rechts oben.
 * Weitere Rollen (Schüler, Verwaltung) bleiben im Profil.
 */
export default function AreaSwitchControl({ onOpenPicker, light = false }) {
  const { me, area, switchArea } = useMobile();
  const areas = switchableAreas(me?.areas || []);
  const hasLehrer = areas.includes('lehrer');
  const hasEltern = areas.includes('eltern');

  if (areas.length < 2) return null;

  const fg = light ? '#fff' : C.text;
  const bg = light ? 'rgba(255,255,255,0.18)' : C.bg;
  const border = light ? 'rgba(255,255,255,0.35)' : C.border;
  const activeBg = light ? '#fff' : C.header;
  const activeFg = light ? C.header : '#fff';

  if (hasLehrer && hasEltern && (isStaffArea(area) || area === 'eltern' || area === 'schueler')) {
    const extra = areas.some((item) => item !== 'lehrer' && item !== 'eltern');
    const segment = (key) => {
      const on = area === key;
      return {
        type: 'button',
        'data-testid': `mobile-area-${key}`,
        'aria-pressed': on,
        onClick: () => switchArea(key),
        className: 'rounded-full px-2 py-1 text-[10px] font-bold',
        style: { background: on ? activeBg : 'transparent', color: on ? activeFg : fg },
      };
    };
    return (
      <div
        role="group"
        aria-label="Rolle wechseln"
        data-testid="mobile-area-toggle"
        className="flex items-center rounded-full p-0.5 self-start"
        style={{ background: bg, border: `1px solid ${border}` }}
      >
        <button {...segment('lehrer')}>{SWITCH_LABEL.lehrer}</button>
        <button {...segment('eltern')}>{SWITCH_LABEL.eltern}</button>
        {extra && (
          <button
            type="button"
            onClick={onOpenPicker}
            data-testid="mobile-area-more"
            aria-label="Weitere Rollen"
            className="rounded-full px-1.5 py-1"
            style={{ color: fg }}
          >
            <ChevronDown className="w-3.5 h-3.5" />
          </button>
        )}
      </div>
    );
  }

  return (
    <button
      type="button"
      onClick={onOpenPicker}
      data-testid="mobile-area-toggle"
      className="flex items-center gap-1 rounded-full px-2.5 py-1 text-[10px] font-bold self-start"
      style={{ background: bg, border: `1px solid ${border}`, color: fg }}
    >
      {AREA_LABEL[area] || area}
      <ChevronDown className="w-3.5 h-3.5" />
    </button>
  );
}
